import { computed, getCurrentInstance } from "@vue/composition-api";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import providers from "@/lib/api";

export default function useBanners() {
  const vm = getCurrentInstance();

  const stateBanners = computed(() => (vm ? (vm.$store.state as StateRoot).banners ?? null : null));

  const banners = computed(() => stateBanners.value ?? []);

  const getBanners = async (options: { forceUpdate: boolean } = { forceUpdate: false }) => {
    if (!options.forceUpdate && stateBanners.value !== null) return;

    const response = await providers.BannersProvider.findAll({ data: { subject: { subjectId: "0" } } });
    vm?.$store.commit(MUTATION_TYPES.SET_BANNERS, response);
  };

  return { banners, getBanners };
}
